import { useTheme } from "@mui/material";
import { useSocketContext } from "~contexts/Socket";
import type { IMessage } from "~contexts/Socket/interfaces";
import { convertToHour } from "~helpers/chat";
import { Wrapper, MessagesList } from "./styles";

interface IProps {
  replyingTo: IMessage | null;
}

const MessageToBeReplied = ({ replyingTo }: IProps) => {
  const theme: any = useTheme();
  const { messagesRooms } = useSocketContext();
  const msgListFromRoom: IMessage[] = Array.from(
    messagesRooms.get(replyingTo?.privateRoom)
  );

  return (
    <Wrapper theme={theme}>
      <div style={{ fontSize: "12px" }}>
        <strong style={{ fontWeight: 900, fontSize: "14px" }}>
          em resposta: {replyingTo?.name}
        </strong>{" "}
        ({replyingTo?.email})
      </div>
      {msgListFromRoom.map((msg: IMessage) => (
        <MessagesList key={msg.time}>
          <span style={{ marginRight: "12px" }}>
            <strong style={{ fontWeight: 900 }}>{msg.name ?? msg.email}</strong>
          </span>
          <span style={{ wordBreak: "break-word" }}>{msg.text}</span>
          <span style={{ marginLeft: "auto" }}>{convertToHour(msg.time)}</span>
        </MessagesList>
      ))}
    </Wrapper>
  );
};

export default MessageToBeReplied;
